import React from "react";
import FileUpload from "./FileUpload";
import { Container } from "react-bootstrap";
import { Checkbox } from "@cdk-uip/react-checkbox";
import _ from "lodash";
import { requiredDocuments } from "../../constants/constants";

export const Attachments = ({
  userId,
  cDKEmployeeType,
  userDocuments,
  setUserDocuments,
  documentsLoading,
  setIsDisclaimerChecked,
  isDisclaimerChecked,
  selectedUploadDocTypes,
  setCandidatePersonalDetails
}) => {
  let selectedDocs =
    (selectedUploadDocTypes && selectedUploadDocTypes.split`,`.map(i => +i)) ||
    [];
  const onChecked = (e, id) => {
    selectedDocs = selectedDocs.includes(id)
      ? _.pull(selectedDocs, id)
      : [...selectedDocs, id];
    setCandidatePersonalDetails(
      "selectedUploadDocTypes",
      selectedDocs.join(",")
    );
  };

  return (
    <div className="w-100 mx-auto pb-3">
      <FileUpload
        userId={userId}
        userDocuments={userDocuments}
        setUserDocuments={setUserDocuments}
        documentsLoading={documentsLoading}
        setIsDisclaimerChecked={setIsDisclaimerChecked}
      />
      <Container className="pb-2">
        <h5 className="pb-4">Required Documents</h5>
        <p className="text-danger">
          Note : Please upload the documents individually with proper names in{" "}
          <b>
            .Pdf format.(e.g.
            Aadhar.pdf,Passport.pdf,ClassTenth.pdf)
          </b>
        </p>
        <p className="text-danger pl-5">
          Maximum size of <b>1MB</b> per document is allowed.
        </p>
        <ul class="list-unstyled">
          {requiredDocuments.map((doc, index) => {
            if (cDKEmployeeType === 3 && index >= 5) {  // it is for interns
              return null;
            }
            return (
              <span className="d-flex align-items-center">
                <Checkbox
                  checked={selectedDocs.includes(index + 1)}
                  onChange={e => {
                    onChecked(e, doc.id);
                  }}
                />
                {doc.description}
              </span>
            );
          })}
        </ul>
      </Container>
      <div className="d-flex align-items-center justify-content-center pb-5 px-5">
        <Checkbox
          checked={isDisclaimerChecked}
          onChange={e => {
            setIsDisclaimerChecked(!isDisclaimerChecked);
          }}
        />
        <p className="font-weight-bold pl-3">
          Disclaimer Acceptance: I hereby agree to provide CDK all information
          including but not limited to my personal information and sensitive
          personal information requested hereinafter in connection with an
          employment opportunity with CDK and I confirm that all information
          provided by me in relation to the same are true and factually correct.
          I understand that CDK may verify or cause to be verified through its
          affiliates and/or any third party the validity and correctness of all
          such information. I further understand that CDK may disclose such
          information and any reference check background verification report
          etc. with its affiliates its clients or any third party(ies) to the
          extent needed in connection with my employment with CDK.
        </p>
      </div>
    </div>
  );
};
export default Attachments;
